import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { StpRegistrationService } from 'src/app/modules/stp-registration/services/stp-registration.service';
import { RequestData } from 'src/app/modules/stp-registration/models/stp_onlinePayment.model';
import { StpRegistrationStorageService } from 'src/app/modules/stp-registration/services/stp-registration-storage.service';
import { StpRegistrationRenewReapplyService } from '../../services/stp-registration-renew-reapply.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-stp-renew-reapply-tab',
  templateUrl: './stp-renew-reapply-tab.component.html',
  styleUrls: ['./stp-renew-reapply-tab.component.scss'],
})
export class StpRenewReapplyTabComponent implements OnInit {
  selectedIndex = 0;
  stpMainInfo$: Subscription;
  stpMainInfo: any;
  requestData: RequestData = new RequestData();
  userInfo: any;
  stpMainId: number;
  applicationId: string;
  stpMainDumpId: number;
  stpMainDumpInfo: any[];
  stpRollbackHistory: any[] = [];
  stpUserStatus: any;

  constructor(
    private stpRegistrationService: StpRegistrationService,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private stpRegistrationRenewReapplyService: StpRegistrationRenewReapplyService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.route.queryParams.subscribe((params) => {
      this.stpMainId = +params['stpMainId']; // convert to number
      this.stpMainDumpId = +params['stpMainDumpId']; // convert to number
    });
    this.getStpDumpInfoByStpMainIdAndStpMainDumpId();
  }

  ngOnInit() {
    this.stpMainInfo$ = this.stpRegistrationService
      .getStpMainInfo()
      .subscribe((res) => {
        this.stpMainInfo = res;
      });

    this.userId();
    this.onUserFullInformationRequest();
  }

  // STP login (same roles as the renew/reapply application view): Rollback History is hidden from it
  get isStpUser(): boolean {
    const role = String(this.userInfo?.roles?.[0]?.name || '').toLowerCase();
    return role === 'user' || role === 'stp_master';
  }

  userId() {
    this.userInfo = JSON.parse(localStorage.getItem('currentUserInfo') || '{}');
    this.requestData.id = this.userInfo.id;
  }

  onUserFullInformationRequest() {
    this.stpRegistrationStorageService
      .stpMainIdByUserId(this.requestData)
      .subscribe({
        next: (res) => {
          if (res.data) {
            this.stpMainId = res.data;
          }
        },
      });
  }

  getStpMainDumpId(id: number) {
    this.stpMainDumpId = id;
  }

  onclickButton() {
    this.selectedIndex = (this.selectedIndex + 1) % 8;
  }

  onclickButtonPrevious() {
    this.selectedIndex = this.selectedIndex - 1;
    if (this.selectedIndex < 0) {
      this.selectedIndex = 8;
    }
  }

  getStpDumpInfoByStpMainIdAndStpMainDumpId() {
    if (!this.stpMainId || !this.stpMainDumpId) {
      return;
    }

    this.stpRegistrationRenewReapplyService
      .readStpDumpInfo(this.stpMainId, this.stpMainDumpId)
      .subscribe({
        next: (res) => {
          if (res?.success) {
            this.stpMainDumpInfo = res.data;
            this.applicationId = res.data?.applicationId;
            this.stpUserStatus = res.data?.stpUserStatus?.id;

            if (this.stpUserStatus === 2) {
              this.getStpRollbackHistory();
            }
          }
        },
        error: (res) => {
          console.error('Error fetching history:', res);
        },
      });
  }

  getStpRollbackHistory() {
    this.stpRegistrationRenewReapplyService
      .readStpRollbackHistory(this.stpMainDumpId)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.stpRollbackHistory = (res.data || []).filter(
              (item: any) => item.rollbackApplicationTypeId === 1,
            );
          } else {
            this.stpRollbackHistory = [];
          }
        },
      });
  }

  ngOnDestroy(): void {
    this.stpMainInfo$.unsubscribe();
  }
}
